export default __webpack_public_path__ + "static/media/svg1.89249992.svg";